require('../polly/presigner');


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/aws-sdk/lib/services/polly.js
// module id = 1674
// module chunks = 4